<header *ngIf="!isMobileRender" class="header" [class.open]="showSlideMenu">
  <div class="content-max-width" (click)="$event.stopPropagation()">
    <div class="left">
      <a (click)="back.emit()" *ngIf="showBackButton" class="back-btn-header">
        <span></span>
      </a>
      <a class="logo" href="/au">
        <img async src="https://static.zip.co/logo/zip-logo.svg" alt="zip logo" />
      </a>
    </div>
    <div class="right" (click)="$event.stopPropagation()">
      <ul class="main-links">
        <li>
          <a href="/au/shop">Shop</a>
        </li>
        <li>
          <a href="/au/how-zip-works">How it works</a>
        </li>
        <li>
          <a href="/au/business">Are you a business?</a>
        </li>
        <li>
          <a href="https://help.zip.co" target="_blank">Help</a>
        </li>
      </ul>
      <zip-co-country-switcher></zip-co-country-switcher>
      <span class="login-seperator"></span>
      <div class="button-header-wrapper">
        <div class="zip-button-header" (click)="toggleDropDown()">
          Sign In
          <zip-co-header-drop-down
            (click)="$event.stopPropagation()"
            [class.is-hiding]="dropDownIsHiding"
            *ngIf="showDropDown"
          >
          </zip-co-header-drop-down>
        </div>
        <a href="/au/create-an-account" class="zip-button-header dark-blue is-bigger">Apply Now</a>
      </div>
    </div>
    <button class="menu-toggle" [class.open]="showSlideMenu" (click)="toggleSlideMenu()">
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
      <span class="icon-bar"></span>
    </button>
    <div class="app-info">
      <p>Buy now, pay later,<br />for Android & iOS</p>
      <div class="app-info__icons">
        <a href="https://apps.apple.com/au/app/zip/id1411824359"
          ><img src="https://static.zip.co/assets/app-icons/btn-appstore.svg" alt="app icons"
        /></a>
        <a href="https://play.google.com/store/apps/details?id=co.zip"
          ><img src="https://static.zip.co/assets/app-icons/btn-google.svg" alt="app icons"
        /></a>
      </div>
    </div>
  </div>
</header>
